import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, ArrowLeft, Home } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

// Écran « accès refusé » (proposition UI validée par William le 07/09/2026).
// Avant : une impasse — un cadre « Acces limite » sans bouton ni explication.
// Maintenant : ce qui manque (le droit, nommé pour le superadmin qui peut
// l'accorder), et deux sorties : retour, accueil. Une seule implémentation pour
// ProtectedRoute et les pages qui refusaient à la main.
const CARD = {
  maxWidth: 520, background: '#fff', border: '1px solid #d7e3ef',
  boxShadow: '0 20px 50px rgba(26,58,92,0.08)', borderRadius: 16, padding: 28,
  fontFamily: "'IBM Plex Sans', sans-serif",
};
const BTN = {
  display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 6,
  border: '1px solid #2563a8', background: '#fff', color: '#2563a8', cursor: 'pointer',
  fontSize: 13, fontWeight: 600, fontFamily: 'inherit',
};

export default function AccessDenied({ permissions = [], title, message }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const perms = (Array.isArray(permissions) ? permissions : [permissions]).filter(Boolean);
  const isSuperadmin = user?.role === 'superadmin';
  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={CARD} role="alert">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
          <Lock size={20} color="#1a3a5c" />
          <div style={{ fontSize: 20, fontWeight: 700, color: '#1a3a5c' }}>
            {title || "Cette page demande un droit que vous n'avez pas"}
          </div>
        </div>
        <p style={{ margin: 0, color: '#6b7d8f', lineHeight: 1.6, fontSize: 14 }}>
          {message || "Votre rôle actuel ne permet pas d'ouvrir cette section du portail. Si vous en avez besoin, demandez-le à un administrateur."}
        </p>
        {perms.length > 0 && (
          <p style={{ margin: '10px 0 0', color: '#6b7d8f', fontSize: 13 }}>
            Droit requis : {perms.map(p => <code key={p} style={{ background: '#f4f7fb', padding: '1px 6px', borderRadius: 4, marginRight: 4 }}>{p}</code>)}
            {isSuperadmin && <span> — à accorder dans Utilisateurs › Rôles et permissions.</span>}
          </p>
        )}
        <div style={{ display: 'flex', gap: 8, marginTop: 18 }}>
          <button type="button" style={BTN} onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}>
            <ArrowLeft size={14} /> Retour
          </button>
          <button type="button" style={{ ...BTN, background: '#2563a8', color: '#fff' }} onClick={() => navigate('/')}>
            <Home size={14} /> Accueil
          </button>
        </div>
      </div>
    </div>
  );
}
